// copied from https://codesandbox.io/embed/material-ui-cascading-menu-fvsl4

import React from 'react';
import { PropTypes } from 'prop-types';
import { Settings } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import CascadingMenu from '../CascadingMenu/CascadingMenu';
import { simulationMenu, languageMenu } from '.';
import VEHICLE_CAPABLE_ACTION from '../../redux-saga/actionTypes/VehicleCapable';
import SUBSCRIPTION_ACTION from '../../redux-saga/actionTypes/Subscriptions';
import { QRVALUE_ACTION_TYPES } from '../../redux-saga/actionTypes';
import FORGEROCK_ACTION_TYPES from '../../redux-saga/actionTypes/ForgeRock';
import REMOTE_STATUS_ACTION from '../../redux-saga/actionTypes/UpdateRemoteSubscription';
import styles from './styles';


class TestNativeFeatures extends React.PureComponent {
  menuItems = [];

  constructor(props) {
    super(props);
    this.state = {
      anchorElement: null,
      selectedLang: 'en',
    };
    this.menuItems.push(simulationMenu(this.props), languageMenu(this.props.t));
  }

  /**
   * @name render
   * @description react component render
   */
  render() {
    const { anchorElement } = this.state;

    return (
      <>
        <IconButton
          aria-label="Toggle User Menu"
          aria-controls="user-menu"
          aria-haspopup="true"
          className={this.props.classes.footerButton}
          onClick={this.handleClick}
        >
          <Settings className={this.props.classes.footer} />
        </IconButton>
        <CascadingMenu
          anchorElement={anchorElement}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          menuItems={this.menuItems}
          onClose={this.handleClose}
          open={Boolean(anchorElement)}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        />
      </>
    );
  }

  /**
   * @name handleClick
   * @description handle Click on Menu Root(Settings) icon
   */
  handleClick = event => this.setState({ anchorElement: event.currentTarget });

  /**
   * @name handleClose
   * @description handle menu close event
   */
  handleClose = () => this.setState({ anchorElement: null });
}

TestNativeFeatures.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  getVehicleCapable: () => dispatch({ type: VEHICLE_CAPABLE_ACTION.IS_VEHICLE_CAPABLE }),
  vehicleCapableError: () => dispatch({ type: VEHICLE_CAPABLE_ACTION.VEHICLE_CAPABLE_ERROR, payload: 'error' }),
  subscriptionError: () => dispatch({ type: SUBSCRIPTION_ACTION.IS_SUBSCRIPTION }),
  getQrAuthValue: () => dispatch({ type: QRVALUE_ACTION_TYPES.POST.IN_PROGRESS }),
  authSuccess: () => dispatch({ type: FORGEROCK_ACTION_TYPES.IS_AUTHORIZED, payload: 'success' }),
  updateAuthStatus: () => dispatch({ type: REMOTE_STATUS_ACTION.IS_REMOTE_SUBSCRIPTION, payload: 'completed' }),
});

export default withStyles(styles)(
  connect(
    null,
    mapDispatchToProps,
  )(withTranslation()(TestNativeFeatures)),
);
